const UUID_FILENAME_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.[a-z0-9]+$/i;

const SERIALIZED_PATH_PATTERN = /-_(pp|ll)_\1_-/g;

const S3_KEY_WITH_ENV_REGEX = /^(?:dev|hml|prod|stg)customer[0-9a-f]{24,}([\w.\-]+\.[a-z0-9]+)$/i;

const DEFAULT_FALLBACK_NAME = 'documento';

function basename(value: string): string {
  const normalized = value.replace(/\\/g, '/');
  const last = normalized.split('/').pop();
  return last ?? value;
}

export function sanitizeAttachmentFilename(name?: string | null, fallbackExt = 'bin'): string {
  let candidate = (name ?? '').toString().trim();
  if (!candidate) {
    return `${DEFAULT_FALLBACK_NAME}.${fallbackExt}`;
  }

  candidate = candidate.replace(SERIALIZED_PATH_PATTERN, '/');
  candidate = basename(candidate);

  const concatenatedKey = candidate.match(S3_KEY_WITH_ENV_REGEX);
  if (concatenatedKey) {
    candidate = concatenatedKey[1];
  }

  if (UUID_FILENAME_REGEX.test(candidate)) {
    const ext = candidate.split('.').pop() || fallbackExt;
    return `${DEFAULT_FALLBACK_NAME}.${ext}`;
  }

  return candidate || `${DEFAULT_FALLBACK_NAME}.${fallbackExt}`;
}
